import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../lib/db'
import { useAuth } from '../contexts/AuthContext'
import { renderActivityCard } from '../lib/activityCard'
import { groupActivityByRound } from '../lib/activityGroup'

// Full activity list — accessed from the "See all" link on HomePage.
// Same card rendering as HomePage's Recent Activity, but paginated to
// 50 rows and with a top-right filter dropdown (All / Just Me / My Friends).
export default function ActivityPage() {
  const navigate = useNavigate()
  const { player } = useAuth()
  const [filter, setFilter] = useState('all')
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    if (!player?.id) return
    setLoading(true)
    ;(async () => {
      try {
        const { data } = await db('get_recent_activity', {
          player_id: player.id,
          filter,
          limit: 50,
        })
        if (!cancelled) setRows(data || [])
      } catch { if (!cancelled) setRows([]) }
      finally { if (!cancelled) setLoading(false) }
    })()
    return () => { cancelled = true }
  }, [player?.id, filter])

  const filterLabel = useMemo(() => (
    filter === 'just_me' ? 'Just Me' :
    filter === 'my_friends' ? 'My Friends' :
    'All'
  ), [filter])

  return (
    <div className="page">
      <div className="container">
        <div style={{ paddingTop: 12, paddingBottom: 12, borderBottom: '1px solid var(--green-mid)', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            onClick={() => navigate('/')}
            style={{ background: 'none', border: 'none', color: 'var(--cream)', fontSize: '1.2rem', cursor: 'pointer', padding: '4px 0' }}
          >‹</button>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontFamily: 'var(--font-mono)', fontSize: '0.62rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--gold)', marginBottom: 2 }}>Activity</p>
            <h1 style={{ fontSize: '1.4rem', margin: 0, lineHeight: 1.2 }}>All Rounds</h1>
          </div>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            aria-label="Filter activity"
            style={{
              flexShrink: 0,
              background: 'var(--green-deep)',
              border: '1px solid var(--green-mid)',
              borderRadius: 8,
              color: 'var(--cream)',
              fontFamily: 'var(--font-body)',
              fontSize: '0.85rem',
              padding: '6px 10px',
              cursor: 'pointer',
            }}
          >
            <option value="all">All</option>
            <option value="just_me">Just Me</option>
            <option value="my_friends">My Friends</option>
          </select>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 48 }}>
            <div className="spinner" style={{ margin: '0 auto' }} />
          </div>
        ) : rows.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 48, color: 'var(--gray-300)' }}>
            <p style={{ fontSize: '2rem', marginBottom: 8 }}>🏌️</p>
            <p>No {filterLabel === 'All' ? '' : `${filterLabel.toLowerCase()} `}activity yet.</p>
          </div>
        ) : (
          <div className="home-activity-group">
            {groupActivityByRound(rows, player?.id).map((r, i) => renderActivityCard({ r, i, player, navigate }))}
          </div>
        )}
      </div>
    </div>
  )
}
